import { msGetFeeTiersByLevelByCentre } from 'services/FinanceService';
import {
  msGetAllTransferDrafts,
  msApproveTransferRequestDestination,
  msRejectTransferRequestDestination,
  msNewTransferRequest,
} from 'services/ChildService';
import SkRequest from './BaseRequest';
import { MutationBuilder, QueryBuilder } from '../queryBuilder';
import {
  FETCH_ALL_TRANSFER_DRAFTS,
  IS_VACANCY_AVAILABLE,
  FETCH_ALL_COMPLETED_DRAFTS,
  FETCH_TRANSFER_DRAFTS_LOADING,
  FETCH_TRANSFER_DRAFTS_SUCCESS,
  FETCH_TRANSFER_DRAFTS_ERROR,
  FETCH_ALL_VACANCY,
  FETCH_CENTRE_VACANCY,
  HAS_LEAD_OFFERED,
  FEE_TIERS_BY_CHILD_CENTRE,
} from './actionTypes';
import {
  GET_ALL_TRANSFER_DRAFTS,
  GET_ALL_AVAILABLE_VACANCY,
  GET_CENTRE_AVAILABLE_VACANCY,
  GET_LEAD_OFFERED_FOR_TRANSFER,
  GET_FEE_TIERS_BY_CHILD_CENTRE,
  SUBMIT_NEW_TRANSFER_REQUEST,
} from '../models/transferModel';
import { SkApolloRequest } from '../../utils/apolloUtils';
import DatadogHandler from '../../utils/datadog';
import { actionHandlerWithFeatureFlag } from '../../utils';
import { FEATURE_FLAGS } from '../../utils/constants';
import {
  msGetAllAvailableVacancy,
  msGetLeadOfferedForTransfer,
  msGetCentreAvailableVacancy,
  msApproveTransferRequestSource,
  msRejectTransferRequestSource,
} from '../../services/TransferService';
import { msCancelTransferRequestByUser } from '../../services/ChildService';

const fileName = 'redux/actions/TransferManagement.js';
const _mMutationBuilder = new MutationBuilder();
const _mQueryBuilder = new QueryBuilder();

_mMutationBuilder.setNewMutation('approveTransferRequestBySourceCentreStaff', {
  ID: 'number',
});
_mMutationBuilder.setNewMutation(
  'approveTransferRequestByDestinationCentreStaff',
  {
    ID: 'number',
  }
);
_mMutationBuilder.setNewMutation('cancelTransferRequestByUser', {});

_mMutationBuilder.setNewMutation(
  'rejectTransferRequestBySourceCentreStaff',
  {}
);

_mMutationBuilder.setNewMutation(
  'rejectTransferRequestByDestinationCentreStaff',
  {}
);

_mMutationBuilder.setNewMutation('completeTransferRequest', {});

_mQueryBuilder.setNewQuery('getTransferDrafts', {
  totalCount: 'number',
  data: {
    ID: 'number',
    vacancyAvailableForTransferRequest: 'boolean',
    status: 'string',
    additionalStatus: 'string',
    withdrawalEConsentCompleted: 'boolean',
    destinationCentreEnrollmentCompleted: 'boolean',
    destinationCentreFkFeeTier: 'number',
    centreByFkCentre: {
      ID: 'number',
      label: 'string',
    },
    centreByDestinationFkCentre: {
      ID: 'number',
      label: 'string',
    },
    userBySourceCentreFkApprover: {
      ID: 'number',
      firstname: 'string',
      lastname: 'string',
    },
    userByDestinationCentreFkApprover: {
      ID: 'number',
      firstname: 'string',
      lastname: 'string',
    },
    forms: {
      data: {
        formParticipants: {
          data: {
            ID: 'number',
            status: 'string',
            email: 'string',
            createdAt: 'datetime',
            updatedAt: 'datetime',
            fkParent: 'number',
            user: {
              firstname: 'string',
              lastname: 'string',
              getRole: {
                label: 'string',
              },
            },
          },
        },
      },
    },
    getTransferDraftFeeTier: {
      label: 'string',
    },
    transferDraftItem: {
      ID: 'number',
      fkRegistration: 'number',
      fkEcdaRegistration: 'number',
      registration: {
        registrationChildMappings: {
          data: {
            ID: 'number',
            fkRegistrationChild: 'number',
          },
        },
      },
      ecdaRegistration: {
        fkEcdaRegistrationChild: 'number',
      },
      fkDraft: 'number',
      otherReason: 'string',
      level: {
        ID: 'number',
        label: 'string',
      },
      program: {
        ID: 'number',
        label: 'string',
      },
      child: {
        ID: 'number',
        firstname: 'string',
        lastname: 'string',
        currentFee: {
          amount: 'number',
        },
      },
      user: {
        ID: 'number',
        firstname: 'string',
        lastname: 'string',
      },
      centreBySourceCentre: {
        ID: 'number',
        label: 'string',
      },
      centreByDestinationCentre: {
        ID: 'number',
        label: 'string',
      },
      refundFeeAmount: 'number',
      refundDepositAmount: 'number',
      effectiveDate: 'datetime',
      code: {
        ID: 'number',
        label: 'string',
        description: 'string',
      },
      fkEnquiry: 'number',
      remark: 'string',
      createdAt: 'datetime',
      notificationDate: 'datetime',
    },
  },
});
_mQueryBuilder.setNewQuery('getCompletedTransferRequests', {
  totalCount: 'number',
  data: {
    ID: 'number',
    child: {
      ID: 'number',
      firstname: 'string',
      lastname: 'string',
    },
    user: {
      ID: 'number',
      firstname: 'string',
      lastname: 'string',
    },
    centreBySourceCentre: {
      ID: 'number',
      label: 'string',
    },
    centreByDestinationCentre: {
      ID: 'number',
      label: 'string',
    },
    refundFeeAmount: 'number',
    refundDepositAmount: 'number',
    effectiveDate: 'timestamp',
    createdAt: 'datetime',
    code: {
      ID: 'number',
      label: 'string',
      description: 'string',
    },
    fkEnquiry: 'number',
    remark: 'string',
  },
});

_mQueryBuilder.setNewQuery('vacancyAvailableInCentreForLevel', {});

const transferDraftsLoading = () => ({
  type: FETCH_TRANSFER_DRAFTS_LOADING,
  key: 'allTransferDrafts',
  value: {
    inProgress: true,
  },
});

const transferDraftsSuccess = data => ({
  type: FETCH_TRANSFER_DRAFTS_SUCCESS,
  key: 'allTransferDrafts',
  value: {
    inProgress: false,
    data,
  },
});

const transferDraftsError = error => ({
  type: FETCH_TRANSFER_DRAFTS_ERROR,
  key: 'allTransferDrafts',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const dispatchFetchTransferDrafts = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_TRANSFER_DRAFTS,
    key: 'findAllTransferDrafts',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchCompletedDrafts = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_COMPLETED_DRAFTS,
    key: 'findAllCompletedDrafts',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchCheckVacancyAvailable = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: IS_VACANCY_AVAILABLE,
    key: 'checkVacancyAvailable',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAllAvailableVacancy = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_VACANCY,
    key: 'allVacancy',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchCentreAvailableVacancy = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_CENTRE_VACANCY,
    key: 'allCentreVacancy',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchLeadOfferedForTransfer = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: HAS_LEAD_OFFERED,
    key: 'hasLeadOffered',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFeeTiersByChildByCentre = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FEE_TIERS_BY_CHILD_CENTRE,
    key: 'feeTiersByChildByCentre',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const monoNewTransferRequest = async reqData => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: SUBMIT_NEW_TRANSFER_REQUEST,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const newTransferRequest = reqData => async () => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: () => msNewTransferRequest(reqData),
        monoHandler: () => monoNewTransferRequest(reqData),
      }
    );
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoApproveTransferRequestSource = async (_, reqData) => {
  try {
    const data = await SkRequest({
      data: {
        query: _mMutationBuilder.getMutationAsString(
          'approveTransferRequestBySourceCentreStaff',
          reqData
        ),
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const approveTransferRequestSource = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msApproveTransferRequestSource,
    monoHandler: monoApproveTransferRequestSource,
    extraData: reqData,
  });

export const monoRejectTransferRequestSource = async (_, reqData) => {
  try {
    const data = await SkRequest({
      data: {
        query: _mMutationBuilder.getMutationAsString(
          'rejectTransferRequestBySourceCentreStaff',
          reqData
        ),
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const rejectTransferRequestSource = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msRejectTransferRequestSource,
    monoHandler: monoRejectTransferRequestSource,
    extraData: reqData,
  });

export const monoApproveTransferRequestDestination = async (_, reqData) => {
  try {
    return SkRequest({
      data: {
        query: _mMutationBuilder.getMutationAsString(
          'approveTransferRequestByDestinationCentreStaff',
          reqData
        ),
      },
      method: 'POST',
    });
  } catch (ex) {
    return ex;
  }
};

export const approveTransferRequestDestination = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msApproveTransferRequestDestination,
    monoHandler: monoApproveTransferRequestDestination,
    extraData: reqData,
  });

export const monoRejectTransferRequestDestination = async (_, reqData) => {
  try {
    return SkRequest({
      data: {
        query: _mMutationBuilder.getMutationAsString(
          'rejectTransferRequestByDestinationCentreStaff',
          reqData
        ),
      },
      method: 'POST',
    });
  } catch (ex) {
    return ex;
  }
};

export const rejectTransferRequestDestination = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msRejectTransferRequestDestination,
    monoHandler: monoRejectTransferRequestDestination,
    extraData: reqData,
  });

export const monoCancelTransferRequestByUser = (_, reqData) => {
  try {
    return SkRequest({
      data: {
        query: _mMutationBuilder.getMutationAsString(
          'cancelTransferRequestByUser',
          reqData
        ),
      },
      method: 'POST',
      timeout: 90000,
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoCancelTransferRequestByUser',
      },
      'error'
    );

    return {
      error: ex.message,
    };
  }
};

export const cancelTransferRequestByUser = reqData => () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCancelTransferRequestByUser,
      monoHandler: monoCancelTransferRequestByUser,
      extraData: reqData,
    }
  );
};

export const completedTransferRequest = reqData => async () => {
  try {
    const data = await SkRequest({
      data: {
        query: _mMutationBuilder.getMutationAsString(
          'completeTransferRequest',
          reqData
        ),
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoFetchAllTransferRequests = async (_, reqData) => {
  try {
    const query = _mQueryBuilder.getQueryAsString('getTransferDrafts', reqData);
    const data = await SkRequest({
      data: {
        query,
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    throw ex;
  }
};

export const fetchAllTransferRequests = reqData => async dispatch => {
  dispatchFetchTransferDrafts(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msGetAllTransferDrafts,
        monoHandler: monoFetchAllTransferRequests,
        extraData: reqData,
      }
    );

    if (data.success) {
      const responseData = data.data?.getAllTransferDrafts || data.data;
      dispatchFetchTransferDrafts(dispatch, false, { data: responseData });
    } else {
      dispatchFetchTransferDrafts(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchFetchTransferDrafts(dispatch, false, null, {
      error: ex.message,
    });
  }
};

export const fetchAllCompletedTransferRequests = reqData => async dispatch => {
  dispatchFetchCompletedDrafts(dispatch);
  const query = _mQueryBuilder.getQueryAsString(
    'getCompletedTransferRequests',
    reqData
  );
  try {
    const data = await SkRequest({
      data: {
        query,
      },
      method: 'POST',
    });
    if (data.success) {
      dispatchFetchCompletedDrafts(dispatch, false, { data: data.data });
    } else {
      dispatchFetchCompletedDrafts(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchFetchCompletedDrafts(dispatch, false, null, {
      error: ex.message,
    });
  }
};

export const checkAllVacancyAvailable = reqData => async dispatch => {
  dispatchCheckVacancyAvailable(dispatch);
  const query = _mQueryBuilder.getQueryAsString(
    'vacancyAvailableInCentreForLevel',
    reqData
  );
  try {
    const data = await SkRequest({
      data: {
        query,
      },
      method: 'POST',
    });
    if (data.success) {
      dispatchCheckVacancyAvailable(dispatch, false, { data: data.data });
    } else {
      dispatchCheckVacancyAvailable(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchCheckVacancyAvailable(dispatch, false, null, {
      error: ex.message,
    });
  }
};

export const monoGetAllTransferDrafts = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_ALL_TRANSFER_DRAFTS,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    throw ex;
  }
};

export const getAllTransferDrafts = reqData => async dispatch => {
  dispatch(transferDraftsLoading());
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllTransferDrafts,
        monoHandler: monoGetAllTransferDrafts,
        extraData: reqData,
      }
    );

    if (data.success) {
      dispatch(transferDraftsSuccess(data.data));
    } else {
      dispatch(transferDraftsError(data.error));
    }
  } catch (ex) {
    dispatch(transferDraftsError(ex?.ex?.message));
  }
};

export const monoGetAllAvailableVacancy = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_ALL_AVAILABLE_VACANCY,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoGetAllAvailableVacancy',
      },
      'error'
    );
    dispatchAllAvailableVacancy(dispatch, false, null, {
      error: ex.message,
    });
    return { error: ex.message };
  }
};

export const getAllAvailableVacancy = reqData => async dispatch => {
  dispatchAllAvailableVacancy(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllAvailableVacancy,
        monoHandler: monoGetAllAvailableVacancy,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatchAllAvailableVacancy(dispatch, false, { data: data.data });
    } else {
      dispatchAllAvailableVacancy(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoGetCentreAvailableVacancy = async (dispatch, reqData) => {
  dispatchCentreAvailableVacancy(dispatch);
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_CENTRE_AVAILABLE_VACANCY,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const getCentreAvailableVacancy = reqData => async dispatch => {
  dispatchCentreAvailableVacancy(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetCentreAvailableVacancy,
        monoHandler: monoGetCentreAvailableVacancy,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatchCentreAvailableVacancy(dispatch, false, { data: data.data });
    } else {
      dispatchCentreAvailableVacancy(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchCentreAvailableVacancy(dispatch, false, null, {
      error: ex.message,
    });
  }
};

export const monoGetLeadOfferedForTransfer = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_LEAD_OFFERED_FOR_TRANSFER,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoGetLeadOfferedForTransfer',
      },
      'error'
    );
    dispatchLeadOfferedForTransfer(dispatch, false, null, {
      error: ex.message,
    });
    return { error: ex.message };
  }
};

export const getLeadOfferedForTransfer = reqData => async dispatch => {
  dispatchLeadOfferedForTransfer(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetLeadOfferedForTransfer,
        monoHandler: monoGetLeadOfferedForTransfer,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatchLeadOfferedForTransfer(dispatch, false, { data: data.data });
    } else {
      dispatchLeadOfferedForTransfer(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchLeadOfferedForTransfer(dispatch, false, null, {
      error: ex.message,
    });
  }
};

export const monoGetFeeTiersByLevelByCentre = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_FEE_TIERS_BY_CHILD_CENTRE,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoGetFeeTiersByLevelByCentre',
      },
      'error'
    );
    throw ex;
  }
};

export const getFeeTiersByLevelByCentre = reqData => async dispatch => {
  dispatchFeeTiersByChildByCentre(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetFeeTiersByLevelByCentre,
        monoHandler: monoGetFeeTiersByLevelByCentre,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatchFeeTiersByChildByCentre(dispatch, false, { data: data.data });
    } else {
      dispatchFeeTiersByChildByCentre(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchFeeTiersByChildByCentre(dispatch, false, null, {
      error: ex.message,
    });
  }
};

export default newTransferRequest;
